<template>
  <v-container class="fill-height login" fluid>
    <v-row justify="center">
      <v-col cols="12" lg="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{ $t("password_reset") }}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form v-model="valid">
              <v-row no-gutters>
                <v-col cols="12">
                  <text-field
                    v-model="password"
                    :rules="[rules.required, rules.password]"
                    type="password"
                    :placeholder="$t('password')"
                  />
                </v-col>
                <v-col cols="12">
                  <text-field
                    v-model="confirmPassword"
                    :rules="[rules.required, rules.repeatPassword]"
                    type="password"
                    :placeholder="$t('repeat_password')"
                  />
                </v-col>
              </v-row>

              <v-card-actions>
                <v-spacer></v-spacer>
                <primary-button
                  :loading="loading"
                  :disabled="!valid"
                  :dark="valid"
                  @click="reset"
                  >{{ $t("save") }}
                </primary-button>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import hasValidation from "@/mixins/hasValidation";
import hasSnackbar from "@/mixins/hasSnackbar";
import userService from "@/services/user";

export default {
  mixins: [hasValidation, hasSnackbar],
  data: () => ({
    valid: false,
    password: "",
    confirmPassword: "",
    loading: false,
  }),
  methods: {
    reset() {
      this.loading = true;
      userService
        .resetPassword(this.$route.query.token, this.password)
        .then((res) => {
          this.showSuccessSnackbar(this.$t("password_reset_success"));
          this.loading = false;
          setTimeout(() => {
            this.$router.push({ name: 'login' });
          }, 2000);
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("password_reset_expired"));
          this.loading = false;
        });
    },
  },
};
</script>
